import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import * as actionsPicking from '../../../../actions/pickingAction';
import ListItemSupplier from './ListItemSupplier';
import PickingService from '../../../../services/PickingService';
import { ENUMS } from '../../../../utils/constants';
import ListPagination from '../../../../components/UI/ListPaginationUl';

const ListSupplier = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [suppliers, setSuppliers] = useState([]);

    useEffect(() => {
        if (props.suppliers?.items?.length > 0) {
            if (suppliers.length > 0 && currentPage === 0) {
                setSuppliers(props.suppliers.items);
            } else {
                setSuppliers((prevState) => ([...prevState, ...props.suppliers.items]));
            }
        }
        // eslint-disable-next-line
    }, [props.suppliers.items]);

    useEffect(() => {
        var filter = {
            PageSize: ENUMS.ePagination.PageSize.value,
            PageIndex: currentPage,
            orderType: ENUMS.eOrderType.Picking.value
        }
        props.getSuppliers(props.user.vision, filter);
        // eslint-disable-next-line
    }, [currentPage]);

    const onSelectItemChange = (item) => {
        props.filter.supplierCode = item.key;
        props.filter.orderType = ENUMS.eOrderType.Picking.value;
        props.setFilterSupplier(props.filter);
    };

    return suppliers ? (
        <div id="listSuppliers">
            <ListPagination
                page={props.suppliers.totalPages}
                current={{ currentPage, setCurrentPage }}
                data={
                    suppliers.map((item, index) => {
                        return (
                            <ListItemSupplier
                                // eslint-disable-next-line react/no-array-index-key
                                key={`oi-${index}`}
                                route="../orders"
                                data={item}
                                onSelectChange={() => onSelectItemChange(item)}
                            />
                        );
                    })
                }
            />
        </div>
    ) : null;
};

const mapStateToProps = (state) => {
    return {
        filter: state.pickingReducer.filter,
        suppliers: state.pickingReducer.suppliers,
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilterSupplier: (filter) => {
            dispatch(actionsPicking.setFilter(filter));
        },
        getSuppliers: (vision, filter) => {
            dispatch(PickingService.getSuppliers(vision, filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListSupplier)));
